import { useQuery } from '@tanstack/react-query';
import { fetchQuotes } from '../apis/fetchQuotes';

export function useFetchQuotes() {
  return useQuery({
    queryKey: ['quotes'],
    queryFn: async () => {
      const response = await fetchQuotes();
      return response.data || [];
    },
  });
}
